<template>
  <a-config-provider :locale="locale === 'zh-CN' ? zhCN : enUS">
    <ToastContainer />
    <router-view />
    <GlobalLoading />
    <!-- 
    <UpdateModal
      v-model:visible="visible"
      :app-version="appVersion"
      :latest-version="latestVersion"
      :change-log="changeLog"
      :is-show-new-version="isShowNewVersion"
      @ok="handleOk"
      @cancel="handleCancel"
    /> -->

    <iframe
      id="sso-iframe"
      :src="`${ssoUrl}/login?domain=${domain}&applicationType=${applicationType}`"
      frameborder="0"
      style="display: none; width: 100%; height: 100%; border: none"
      @load="handleIframeLoad"
    ></iframe>

    <!-- 用户配置弹窗（用于新标签页打开） -->
    <SettingsModal
      v-model="appStore.profileModalVisible"
      :default-tab="appStore.profileDefaultTab"
    />
    <!-- Account 弹窗 -->
    <AccountModal v-model="appStore.accountModalVisible" />
    <CookiePreferencesModal />
    <FeedbackBot />
  </a-config-provider>
</template>

<script lang="ts" setup>
  import { computed, ref, Ref, onMounted, watch } from 'vue';
  import GlobalLoading from '@/components/global-loading/index.vue';
  import ToastContainer from '@/components/toast-container/index.vue';
  // import { UpdateModal } from '@parametrix/ui';
  import { useRoute, useRouter } from 'vue-router';
  import { useAppStore, useUserStore } from '@/store';
  import { iframeMessageManager } from '@/utils/iframeMessage';
  import enUS from '@arco-design/web-vue/es/locale/lang/en-us';
  import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';
  import { useI18n } from 'vue-i18n';
  import SettingsModal from '@/components/settings-modal/index.vue';
  import AccountModal from '@/components/account-modal/index.vue';
  import { getWorkspaceFromUrl } from '@/utils/route';
  import * as Sentry from '@sentry/vue';
  import CookiePreferencesModal from '@/components/cookie-preferences-modal/index.vue';
  import FeedbackBot from '@/components/feedback-bot/index.vue';

  const { locale } = useI18n();

  const route = useRoute();
  const router = useRouter();
  const appStore = useAppStore();
  const userStore = useUserStore();

  const domain = window.location.origin;
  const applicationType = 'individual';
  const ssoUrl = import.meta.env.VITE_SSO_URL;

  // eslint-disable-next-line no-underscore-dangle
  const appVersion = computed(() => import.meta.env.VITE__APP_VERSION__);
  const isShowNewVersion = computed(() => appStore.isShowNewVersion);
  const localPkgVersion = localStorage.getItem('package_version');

  const handleIframeLoad = () => {
    console.log('iframe 加载完成');
    // 标记 iframe 已加载完成，通知路由守卫可以发送消息
    iframeMessageManager.markIframeLoaded();
  };

  // 处理 openProfile 查询参数
  const handleOpenProfile = (openProfile: string) => {
    if (!openProfile) return;

    const workspaceUuid = getWorkspaceFromUrl();

    // 切换到对应的工作空间
    if (workspaceUuid) {
      const workspace = userStore.workspaceList.find(
        (w) => w.workspace_uuid === workspaceUuid
      );
      if (workspace) {
        userStore.setWorkspace(workspace.tenant_uuid, workspaceUuid);
      }
    }
    // 打开用户配置弹窗
    appStore.setProfileDefaultTab(
      (openProfile as 'members' | 'resources') || 'members'
    );
    appStore.openProfileModal();
  };

  onMounted(async () => {
    // 使用消息管理器处理 iframe 消息
    // 路由守卫会优先处理 sso_code，这里作为备用处理
    iframeMessageManager.on('login_status', (key, value) => {
      if (value === false) {
        // toSSO();
      }
    });

    // 等待路由准备就绪
    await router.isReady();

    // 检查 URL 参数，如果包含 openProfile，则打开用户配置弹窗
    const openProfile = route.query.openProfile as string;
    if (openProfile) {
      handleOpenProfile(openProfile);
    }
  });

  // 监听路由查询参数变化
  // watch(
  //   () => route.query.openProfile,
  //   (openProfile) => {
  //     if (openProfile) {
  //       handleOpenProfile(openProfile as string);
  //     }
  //   }
  // );

  const visible = ref(false);
  const latestVersion = ref('');
  const changeLog: Ref<Array<string>> = ref([]);
  const handleCancel = () => {
    appStore.updateSettings({
      isShowNewVersion: false,
    });
  };
  const handleOk = () => {
    window.location.reload();
  };

  watch(
    () => userStore.userInfo,
    (newVal) => {
      console.log('userStore.userInfo changed:', newVal);
      // 同步用户信息到 Sentry
      Sentry.setUser({
        id: newVal.user_uuid,
        email: newVal.email,
        username: newVal.full_name || newVal.nickname,
      });
    },
    {
      immediate: true,
      deep: true,
    }
  );
  // watch(
  //   () => route,
  //   async () => {
  //     const res: any = await axios.get('/version.json');
  //     latestVersion.value = res.version;
  //     if (
  //       (res.pkgVersion !== packageJson.version ||
  //         res.pkgVersion !== localPkgVersion) &&
  //       isShowNewVersion.value
  //     ) {
  //       localStorage.setItem('package_version', res.pkgVersion);
  //       const logs: Array<{
  //         version: string;
  //         date: string;
  //         changes: Array<string>;
  //       }> = await axios.get('/changelog.json');
  //       changeLog.value =
  //         logs.find((log: any) => log.version === res.pkgVersion)?.changes ||
  //         [];
  //       visible.value = true;
  //     }
  //   },
  //   {
  //     immediate: true,
  //     deep: true,
  //   }
  // );
</script>
